/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-star-half': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.156 7.013L.8 7.938l4.6 4.48-1.088 6.332L10 15.762V1.25z"/>'
  }
})
